import React from 'react';

const SvgReports = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path
      d="M20 3.48H4.05a.7.7 0 00-.7.69V20.12a.7.7 0 00.7.69h15.89a.7.7 0 00.71-.69V4.17a.69.69 0 00-.65-.69zm-10.91 6.7v3.93H4.76v-3.93zm1.41 3.93v-3.93h8.74v3.93zm8.74-9.24v3.92H10.5V4.87zm-10.15 0v3.92H4.76V4.87zm0 14.55H4.76V15.5h4.33zm10.15 0H10.5V15.5h8.74z"
      fill="#989898"
    />
  </svg>
);

export default SvgReports;
